module.exports = __webpack_public_path__ + "b57c454dc72c6cce75f02cf5438a1d19.jpg";